// Helpers for the "Odvoz a předání" wizard: API calls, photo downscaling, step status.

export const API = '/api/delivery-protocols';

export async function api(path, { method = 'GET', body, form } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: 'include',
    headers: form ? undefined : { 'Content-Type': 'application/json' },
    body: form || (body !== undefined ? JSON.stringify(body) : undefined),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    const err = new Error(json.details?.[0]?.msg || json.error || `Chyba ${res.status}`);
    err.status = res.status;
    err.data = json.data;
    throw err;
  }
  return json.data;
}

// Downscale a camera photo to max 1600 px and JPEG q0.82 (a 12 MPx phone photo → ~300 kB)
export async function resizeImage(file, max = 1600, quality = 0.82) {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error('Soubor není obrázek'));
      i.src = url;
    });
    const scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    return await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
  } finally {
    URL.revokeObjectURL(url);
  }
}

export const isTr4 = (model) => /^TR4/i.test(String(model || ''));
export const applies = (item, model) => !item.tr4 || isTr4(model);

// 'done' | 'issue' | 'partial' | 'todo' for the stepper
export function stepStatus(step, protocol) {
  const items = step.items.filter((i) => applies(i, protocol.header?.model));
  const st = (k) => protocol.items?.[k] || {};
  const handled = items.filter((i) => st(i.key).checked || (st(i.key).issue && st(i.key).issue_note)).length;
  const signed = protocol.steps?.[step.step]?.checked_by_name && protocol.steps?.[step.step]?.checked_date;
  if (items.some((i) => st(i.key).issue)) return 'issue';
  if (handled === items.length && signed) return 'done';
  return handled > 0 || signed ? 'partial' : 'todo';
}

export const todayIso = () => new Date().toISOString().slice(0, 10);
export const czDate = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return d ? `${Number(d)}. ${Number(m)}. ${y}` : iso;
};
